import { IconButton, Stack, Typography } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import CopyIcon from "assets/svg/CopyIcon";
import { toast } from "react-toastify";
import theme, { responsiveFontSize } from "themes/Theme";
import { trimHash } from "utils/common";
import { formateTransactionDate } from "utils/dateFormat";
import { formatNumber } from "utils/formatter";

export const walletColumn: GridColDef[] = [
  {
    field: "id",
    headerName: "#",
    width: 90,
    renderCell: (params: GridRenderCellParams) =>
      params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
  },
  {
    field: "name",
    headerName: "Name",
    minWidth: 100,
    flex: 1,
    valueGetter: (value, row) => `${row.firstName || ""} ${row.lastName || ""}`,
  },
  {
    field: "email",
    headerName: "Email",
    minWidth: 200,
    flex: 1,
  },
  {
    field: "balance",
    headerName: "Balance",
    minWidth: 100,
    flex: 1,
    renderCell: (params) =>
      params.value
        ? `${formatNumber(params.value)} ${params.row.cryptoTicker}`
        : 0,
  },
  {
    field: "address",
    headerName: "Address",
    minWidth: 100,
    flex: 1,
    renderCell: (params) => (
      <Stack
        direction={"row"}
        alignItems={"center"}
        sx={styles.height100}
        gap={1}
      >
        <Typography
          sx={{
            ...styles.textStyle,
            color:
              params.value !== "-"
                ? theme.palette.text.primary
                : theme.palette.text.primary,
          }}
        >
          {params.value !== "-" ? trimHash(params.value) : "-"}
        </Typography>
        {params.value !== "-" ? (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              copyToClipboard(params.value);
            }}
          >
            <CopyIcon
              width={18}
              height={18}
              color={theme.palette.custom.gradientDark}
            />
          </IconButton>
        ) : null}
      </Stack>
    ),
  },
  {
    field: "createdAt",
    headerName: "Creation Date",
    minWidth: 100,
    flex: 1,
    renderCell: (params) => formateTransactionDate(params.value),
  },
];

const styles = {
  height100: {
    height: "100%",
  },
  statusContainer: {
    textTransform: "capitalize",
    alignSelf: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    fontWeight: 400,
    gap: 1,
  },
  textStyle: {
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
};

const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Address to clipboard successfully");
  } catch (err) {
    toast.error("Failed to copy address to clipboard");
    console.error("Failed to copy: ", err);
  }
};
